/// <reference types="../../../env.d.ts" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

/**
 * Disable console logging in production builds
 * This prevents sensitive data from being logged in production and improves performance
 *
 * Note: import.meta.env.MODE is replaced at build time by Vite
 */
const isProduction = import.meta.env['_NGX_ENV_MODE'] === 'production';

if (isProduction) {
  // Preserve console.error and console.warn for critical issues
  // Only disable console.log, console.info, console.debug
  const noop = () => { /* intentionally empty */ };
  console.log = noop;
  console.debug = noop;
  console.info = noop;

  // Optional: You can also disable these if needed
  // console.warn = noop;
  // console.error = noop;
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
